import PropTypes from 'prop-types';
import React from 'react';
import { List } from 'immutable';
import t from '../../lib/I18n';

import PassengerInfo from '../fares/details/PassengerInfo';
import RailcardBadge from '../fares/details/RailcardBadge';

const LinkedSmartcards = ({ isChild, linkedPassengers, tickets, showRailcardsMessage, hideISRN }) => {
    const isMatchingTicket = ticket =>
        (ticket.adults > 0 && !isChild) || (ticket.children > 0 && isChild);

    const getLinkedTicket = passenger =>
        tickets.find(ticket => ticket.getSmartcardNumber() === passenger.associatedSmartcardNumber);

    return (
        <div className="clearfix">
            {linkedPassengers.size > 0 ? (
                linkedPassengers.map(smartcard => {
                    const matchingTicket = getLinkedTicket(smartcard);
                    return (
                        <div className="order-summary-narrow__fare__ticket">
                            <div className="order-summary-narrow__fare__price__linked-smartcard">
                                <span>
                                    <strong>{smartcard.getCustomerName && smartcard.getCustomerName()}</strong>
                                    {isChild && (
                                        <span className="associated-smartcards__child-badge">
                                            {` ${t('global.child')} `}
                                        </span>
                                    )}
                                </span>
                                {!hideISRN && <span>&nbsp;{smartcard.associatedSmartcardNumber}</span>}
                            </div>
                            {showRailcardsMessage && matchingTicket && matchingTicket.railcard && (
                                <RailcardBadge railcard={matchingTicket.railcard} />
                            )}
                        </div>
                    );
                })
            ) : (
                <div className="margin-bottom--xs">
                    {tickets.filter(isMatchingTicket).map((ticket) => (
                        <div
                            key={ticket.id}
                            className="order-summary-narrow__fare__ticket"
                        >
                            <PassengerInfo
                                className="order-summary-narrow__fare__price__linked-smartcard"
                                hideISRN={hideISRN}
                                ticket={ticket}
                            />
                            {showRailcardsMessage && ticket.railcard && (
                                <RailcardBadge railcard={ticket.railcard} />
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

LinkedSmartcards.propTypes = {
    isChild: PropTypes.bool,
    hideISRN: PropTypes.bool,
    showRailcardsMessage: PropTypes.bool,
    linkedPassengers: PropTypes.instanceOf(List),
    tickets: PropTypes.instanceOf(List)
};

export default LinkedSmartcards;
